<template>
  <div>
    <!--头部-->
    <HeaderForBeauty :showValue="4"></HeaderForBeauty>
    <div class="jqgk">
   <div class="contai" style="max-width: 1197px;background:white;padding-left:40px;padding-right:40px;margin-bottom: 40px">
        <div class="top_tit" style="margin-top: 20px">
          <div v-if="pcshow" style="text-align:left;font-size:20px;height:40px;line-height:40px;font-weight:600;color:rgb(132, 2, 7);padding-top:5px">
            <!-- 720全景游 -->
            </div>
          <div v-if="!pcshow" style="text-align:left;font-size:16px;height:40px;line-height:40px;font-weight:600;color:rgb(132, 2, 7);padding-top:5px">
            720全景游</div>
          <div style="height: 1px; width: 100%"></div>
          <div style="text-align: left; margin: 0px">
            <div class="travel_con">
              <div class="">
                <div v-if="onlyIframeShow">
                <div>
                  <el-button style="background:#840207;color:#FFF;" @click="openBig">全屏</el-button>
                </div>
                <div  v-if="pcshow"  style="margin-right: 0px; margin-top: 20px;" >
                    <iframe  id="iframe-one" name="mainIframe" src="https://720yun.com/t/93vkt97y01l" frameborder="0" scrolling="auto" width="1117" height="600"></iframe>
                </div>
                <div  v-if="!pcshow" style="margin-right: 0px; margin-top: 20px;" >
                    <iframe  id="iframe-one" name="mainIframe" src="https://720yun.com/t/93vkt97y01l" frameborder="0" scrolling="auto" :width="widthForP" height="500"></iframe>
                </div>
                </div>
                <!-- 图片显示 -->
                <!-- <el-row  style="margin-right: 0px; margin-top: 10px">

                  <div v-if="pcshow" class="centerLinShi">
                     <div v-for="item in dataList" :key="item.id">
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                      <a>
                        <div

                          class="showPicture"
                          @click="openUrl(item.url)"
                        >
                          <img
                            :src="item.cover"
                            alt="...."
                            class="sceneryImgSize"
                          />
                          <div v-if="pcshow" class="sceneryFontSize">{{ item.title }}</div>
                          <div v-if="!pcshow" class="sceneryFontSizeFm">{{ item.title }}</div>

                        </div>
                      </a>
                    </el-col>
                  </div>
                  </div>
                  <div v-if="!pcshow" class="centerLinShiForSJ">
                     <div v-for="item in dataList" :key="item.id">
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                      <a>
                        <div

                          class="showPicture"
                          @click="openUrl(item.url)"
                        >
                          <img
                            :src="item.cover"
                            alt="...."
                            class="sceneryImgSize"
                          />
                          <div v-if="pcshow" class="sceneryFontSize">{{ item.title }}</div>
                          <div v-if="!pcshow" class="sceneryFontSizeFm">{{ item.title }}</div>

                        </div>
                      </a>
                    </el-col>
                  </div>
                  </div>

                  </el-row> -->

            </div>
          </div>
        </div>
      </div>
           </div>

<el-dialog
  title="720全景游"
  :visible.sync="iframeShow"
  width="50%"
  :before-close="handleClose">

  <iframe  id="mainIframe" name="mainIframe" src="https://720yun.com/t/8bvkOqpyzrw" frameborder="0" scrolling="auto" width="700" height="400"></iframe>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>

    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getBeautyFor720 } from '@/api/public'
import HeaderForBeauty from './headerforbeauty'
import Footer from './footer'
export default {
  components: { HeaderForBeauty, Footer },
  data () {
    return {
      onlyIframeShow: false,
      iframeShow: false,
      dataList: [],
      pcshow: false,
      widthForP: 300
    }
  },
  beforeCreate () {},
  created () {
    this.widthForP = document.body.clientWidth - 80
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
  },

  mounted () {
    this.initList()
  },

  methods: {
    handleClose () {
      this.iframeShow = false
      this.onlyIframeShow = false
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openUrl (url) {
      this.iframeShow = true
      // window.open(url)
    },
    // 属性排序sort
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    initList () {
      var that = this
      getBeautyFor720().then(response => {
        var list = response.data
        var listCopy = []
        // this.dataList = response.data
        for (let index = 0; index < list.length; index++) {
          if (list[index].title === '720全景游' && list[index].hideIs === 1) {
            listCopy = []
            that.dataList = []
            // window.open(list[index].url)
            that.onlyIframeShow = true
            break
          } else {
            if (list[index].hideIs === 1) {
              listCopy = listCopy.concat(list[index])
            }
          }
        }
        that.dataList = listCopy
        console.log('that.dataList:', that.dataList)
        // list.forEach((item, index, arr) => {

        // })
      })
    },
    openBig () {
      let iframe = document.getElementById('iframe-one')
      this.requestFullScreen(iframe)
    },
    requestFullScreen (element) {
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
      if (requestMethod) {
        requestMethod.call(element)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell')
        if (wscript !== null) {
          wscript.SendKeys('{F11}')
        }
      }
    }
  }
}
</script>

<style>

.centerLinShi{
  text-align: center;
  font-size: 20px;
}
.centerLinShiForSJ{
  text-align: center;
  font-size: 14px;
}
.showPicture {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin: 0 10px 30px 0;
}
/* .sceneryImgSize {
  height: 200px;
} */
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: rgb(132, 2, 7);
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}.sceneryFontSizeFm {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  color: rgb(132, 2, 7);
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/BeautyAllOverFor720.vue